<template>
<div class="home">
  <div class="plk-reg">
    <div class="plk-reg-01">
      <img src="../assets/img/reg/01@2x.png" alt="">
    </div>
    <div class="plk-reg-02">
      <img src="../assets/img/reg/02@2x.png" alt="">
      <div class="plk-reg-form">
        <div class="reg-form-select">
          <div class="form-select-province" @click="showProvince">
            <div class="select-type">
              <div class="select-type-left">
                <span>{{province}}</span>
              </div>
              <div class="select-type-top">
                <img src="../assets/img/reg/10@2x.png" alt="">
              </div>
            </div>
          </div>
          <div class="form-select-div"></div>
          <div class="form-select-city" @click="showCity">
            <div class="select-type">
              <div class="select-type-left">
                <span>{{city}}</span>
              </div>
              <div class="select-type-top">
                <img src="../assets/img/reg/10@2x.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="form-select-type" @click="selectType">
          <div class="select-type">
            <div class="select-type-left">
              <span>{{species}}</span>
            </div>
            <div class="select-type-top">
              <img src="../assets/img/reg/10@2x.png" alt="">
            </div>
          </div>
        </div>
        <div class="form-phone">
          <cube-input type="number" v-model="regphone" class="phone-style" placeholder="请输入手机号"></cube-input>
        </div>
        <div class="form-verify">
          <cube-input type="number" v-model="regverify" class="verify-style" placeholder="请输入验证码"></cube-input>
          <!-- <input type="number" id="regverify" placeholder="请输入验证码"> -->
          <button @click="verifybut" :disabled="isVerify">{{verifystr}}</button>
        </div>
      </div>
      <div class="register-but" @click="validation">
        <img src="../assets/img/reg/07@2x.png" alt="">
      </div>
    </div>
    <div class="plk-reg-03">
      <img src="../assets/img/reg/03@2x.png" alt="">
      <div class="plk-reg-box">
        <div class="plk-reg-share" @click="shareShow">
            <img src="../assets/img/reg/08@2x.png" alt="">
        </div>
        <div class="plk-reg-kefu" @click="kefuShow">
            <img src="../assets/img/reg/09@2x.png" alt="">
        </div>
      </div>
    </div>
    <div class="plk-reg-04">
      <img src="../assets/img/reg/04@2x.png" alt="">
    </div>
    <div class="plk-reg-05">
      <img src="../assets/img/reg/05@2x.png" alt="">
    </div>
    <div class="plk-reg-06">
      <img src="../assets/img/reg/06@2x.png" alt="">
    </div>
  </div>
  <div class="modeshare" v-show="isModeShare">
    <div class="share-guide">
      <img src="../assets/img/guide@2x.png" alt="">
    </div>
    <div class="share-ok">
      <img src="../assets/img/ok@2x.png" alt="" @click="shareHide">
    </div>
  </div>
  <div class="mode" v-show="isMode">
    <div class="dialog-box">
      <div class="dialog-img">
        <img src="../assets/img/reg/11@2x.png" alt="">
        <div class="qrcode">
          <img src="../assets/img/reg/wechat.jpeg" alt="">
        </div>
      </div>
      <div class="dialog-close" id="kefuClose">
        <img src="../assets/img/reg/13@2x.png" alt="" @click="kefuHide">
      </div>
    </div>
  </div>
</div>
</template>

<script>
import md5 from 'js-md5';
import wx from 'weixin-js-sdk'
import { dateToString } from '@/utils/utils.js'
import { province, city, sendCode, register, wxShare, vtSendCode } from '@/api/resetApi.js'

export default {
  name: 'Home',
  data() {
    return {
      isModeShare: false,
      isMode: false,
      options_province: [],
      options_city: [],
      options_species: [{id:'1',name:'养猪场'},{id:'2',name:'养禽场'}],
      value: '',
      province: '请选择省',
      province_id: '',
      city: '请选择市',
      city_id: '',
      species: '请选择养殖种类',
      species_id: '',
      regphone: '',
      regverify: '',
      disabled: false,
      code: '',
      verifystr: '获取验证码',
      isVerify: false,
      time: 60,
      chatTimer: null,
      shareUrl: '',
      imgurl: 'http://saas.sslab.com.cn/plkh5/static/wx.png',
      title: '我又提现啦！买疫苗还能赚钱，我的已经到账了。',
      desc: '好兽药app上线啦，邀请好友注册，邀请一人最高可得12元',
    }
  },
  created(){
    if(this.$route.query.code){
      this.code = this.$route.query.code
    }
    this.plkProvince()
    this.wxShare()
  },
  methods: {
    /*======= 打开关闭弹出层 =======*/
    shareShow() {
      this.isModeShare = !this.isModeShare
      this.stop()
    },
    shareHide() {
      this.isModeShare = !this.isModeShare
      this.move()
    },
    kefuShow() {
      this.isMode = !this.isMode
      this.stop()
    },
    kefuHide() {
      this.isMode = !this.isMode
      this.move()
    },
    /*======= 阻止取消滚动限制 =======*/
    stop() {
      var mo=function(e){passive: false ;};
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",mo,false);//禁止页面滑动
    },
    move() {
      var mo=function(e){passive: false };
      document.body.style.overflow='';//出现滚动条
      document.removeEventListener("touchmove",mo,false);
    },
    /*======= 调取省和市的数据 ======*/
    async plkProvince() {
      const res = await province()
      // console.log('province=',res)
      try {
        if (res.data.code === 200) {
          this.options_province = res.data.data;
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
        // this.options_province = res.data.data;
        // console.log(this.options_province)
      } catch (error) {}
    },
    async plkCity() {
      if (this.province_id) {
        let data = {
          'id': this.province_id
        }
        const res = await city(data)
        try {
          if (res.data.code === 200) {
            this.options_city = res.data.data;
          } else {
            this.$createToast({
              txt: res.data.msg,
              type: 'error'
            }).show()
          }
          // this.options_city = res.data.data;
          // console.log(this.options_city)
        } catch (error) {}
      }
    },
    /*======= 选择省 ======*/
    showProvince() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '请选择省',
          data: [this.options_province],
          alias: {
            value: 'id',
            text: 'name'
          },
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      // console.log('selectedVal=',selectedVal)
      // console.log('selectedIndex=',selectedIndex)
      // console.log('selectedText=',selectedText)
      this.province = selectedText.join()
      this.province_id = selectedVal.join()
      this.plkCity()
    },
    cancelHandle() {
      this.$createToast({
        type: 'correct',
        txt: '取消',
        time: 1000
      }).show()
    },
    /*======= 选择市 ======*/
    showCity() {
      if (this.province_id) {
        // console.log('1111111111=',this.city_id)
        if (!this.picker1) {
          this.picker1 = this.$createPicker({
            title: '请选择省',
            data: [this.options_city],
            alias: {
              value: 'id',
              text: 'name'
            },
            onSelect: this.selectHandle1,
            onCancel: this.cancelHandle
          })
        }
        this.picker1.show()
      } else {
        // console.log('2222222222=',this.city_id)
        const toast = this.$createToast({
          txt: '请先选择省',
          type: 'error'
        })
        toast.show()
      }
    },
    selectHandle1(selectedVal, selectedIndex, selectedText) {
      // console.log('selectedVal=',selectedVal)
      // console.log('selectedIndex=',selectedIndex)
      // console.log('selectedText=',selectedText)
      this.city = selectedText.join()
      this.city_id = selectedVal.join()
    },
    /*======= 选择养殖种类 ======*/
    selectType() {
      if (!this.picker2) {
        this.picker2 = this.$createPicker({
          title: '请选择养殖种类',
          data: [this.options_species],
          alias: {
            value: 'id',
            text: 'name'
          },
          onSelect: this.selectHandle2,
          onCancel: this.cancelHandle
        })
      }
      this.picker2.show()
    },
    selectHandle2(selectedVal, selectedIndex, selectedText) {
      // console.log('selectedVal=',selectedVal)
      // console.log('selectedIndex=',selectedIndex)
      // console.log('selectedText=',selectedText)
      this.species = selectedText.join()
      this.species_id = selectedVal.join()
    },
    /*======= 获取验证码 ======*/
    async verifybut() {
      if (!this.regphone) {
        this.$createToast({
          txt: '请输入手机号',
          type: 'error'
        }).show()
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.regphone)) {
        this.$createToast({
          txt: '请输入正确的手机号码',
          type: 'error'
        }).show()
      } else {
        let myDate = new Date();
        let time = dateToString(myDate)
        let phone = md5(this.regphone)
        let random = md5(phone+time)
        console.log('加密后=',random)
        let data = JSON.stringify({
          'cuPhone': this.regphone,
          'sysCode': 'cus',
          'cpmType': 8,
          'randomSecretkey': random
        })
        const res = await vtSendCode(data)
        // const res = await sendCode(data)
        console.log(res)
        try {
          // console.log('msg=',res)
          let that = this
          if (res.data.code == 200) {
            // console.log('1111111111111=',res.data.msg)
            that.mycode = res.data.data
            that.chatTimer = window.setInterval(function () {
              that.time = that.time - 1;
              that.verifystr = that.time + "秒";
              that.isVerify = true;
              if (that.time == 0) {
                window.clearInterval(that.chatTimer);
                that.verifystr = "重新获取";
                that.time = 60;
                that.isVerify = false;
              }
            }, 1000)
            that.$createToast({
              type: 'correct',
              txt: '验证码发送成功',
              time: 1000
            }).show()
          } else {
            // console.log('222222222222222=',res.data.msg)
            that.mycode = res.data.data
            that.$createToast({
              type: 'error',
              txt: res.data.msg,
            }).show()
          }
        } catch (error) {}
      }
    },
    /*======= 验证表单 ======*/
    validation() {
      if (!this.province_id) {
        this.$createToast({
          txt: '请选择省',
          type: 'error'
        }).show()
      } else if (!this.city_id) {
        this.$createToast({
          txt: '请选择市',
          type: 'error'
        }).show()
      } else if (!this.species_id) {
        this.$createToast({
          txt: '请选择养殖种类',
          type: 'error'
        }).show()
      } else if (!this.regphone) {
        this.$createToast({
          txt: '请输入手机号',
          type: 'error'
        }).show()
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.regphone)) {
        this.$createToast({
          txt: '请输入正确的手机号码',
          type: 'error'
        }).show()
      } else if (!this.regverify) {
        this.$createToast({
          txt: '请输入验证码',
          type: 'error'
        }).show()
      } else {
        if (!this.disabled) {
          this.disabled = true
        } else {
          this.$createToast({
            txt: '请勿连击',
            type: 'error'
          }).show()
        }
        this.regSumbit()
        setTimeout(function () {
          this.disabled = false
        }.bind(this), 1000)
      }
    },
    /*======= 提交注册 ======*/
    async regSumbit() {
      let data = {
        'provinceId': this.province_id,
        'cityId': this.city_id,
        'breedType': this.species_id,
        'phone': this.regphone,
        'recommendCode': this.code,
        'code': this.regverify,
      }
      const res = await register(data)
      try {
        if (res.data.code == 200) {
          this.mycode = res.data.data
          this.$createToast({
            type: 'correct',
            txt: '注册成功',
            time: 1000
          }).show()
          this.province = '请选择省'
          this.province_id = ''
          this.city = '请选择市'
          this.city_id = ''
          this.species = '请选择养殖种类'
          this.species_id = ''
          this.regphone = ''
          this.regverify = ''
        } else {
          this.mycode = res.data.data
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    /*======= 微信分享 ======*/
    async wxShare() {
      // let shareUrl = encodeURIComponent(window.location.href.split('#')[0]);
      // console.log('shareUrl=',shareUrl)
      const res = await wxShare()
      try {
        let that = this
        that.shareUrl = window.location.href;
        console.log('shareUrl=',that.shareUrl)
        if (res.data.code == 200) {
          let shareUrl1 = that.shareUrl + '?code=' + that.mycode;
          console.log('shareUrl2=',shareUrl1)
          let appId = res.data.data.appid;
          let timestamp = res.data.data.timestamp;
          let nonceStr = res.data.data.noncestr;
          let signature = res.data.data.signature;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature,// 必填，签名，见附录1
            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function(){
            let imgurl = that.imgurl;
            let title = that.title;
            let desc = that.desc;
            wx.error(function(res){ // config 信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的 debug 模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
                // alert("errorMSG:"+res.errMsg);
            });

            wx.onMenuShareTimeline({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: shareUrl1, // 分享链接
                imgUrl: imgurl, // 分享图标
                success: function () {
                  // 用户确认分享后执行的回调函数
                  this.$createToast({
                    type: 'correct',
                    txt: '分享成功',
                    time: 1000
                  }).show()
                },
                cancel: function () {
                  // 用户取消分享后执行的回调函数
                  this.$createToast({
                    txt: '分享失败',
                    type: 'error'
                  }).show()
                }
            });

            wx.onMenuShareAppMessage({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: shareUrl1, // 分享链接
                imgUrl: imgurl, // 分享图标
                success: function () {
                  // 用户确认分享后执行的回调函数
                  this.$createToast({
                    type: 'correct',
                    txt: '分享成功',
                    time: 1000
                  }).show()
                },
                cancel: function () {
                  // 用户取消分享后执行的回调函数
                  this.$createToast({
                    txt: '分享失败',
                    type: 'error'
                  }).show()
                }
            });

          });
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  max-width: 768px;
  margin: 0 auto;
}
// 更改select框样式
.plk-reg {
  border: 0;
  margin: 0;
  padding: 0;
  font-size: 0;
  img {
    width: 100%;
  }
  .plk-reg-02 {
    position: relative;
    .plk-reg-form {
      position: absolute;
      top: 0.6rem;
      left: 0.25rem;
      width: 85%;
      .reg-form-select {
        display: flex;
        padding-top: 0.12rem;
        .form-select-province {
          flex: 1;
          .select-type {
            width: 98%;
            height: 0.35rem;
            position: relative;
            padding-right: 0.1rem;
            border-radius: 0.15rem;
            background:rgba(247,244,241,1);
            .select-type-left {
              width: 100%;
              text-align: left;
              line-height: 0.36rem;
              span {
                margin-left: 0.15rem;
                font-size: 0.12rem;
              }
            }
            .select-type-top {
              position: absolute;
              top: 0.1rem;
              right: 0.1rem;
              img {
                width: 0.18rem;
                height: 0.15rem;
              }
            }
          }
        }
        .form-select-div {
          flex: 0 0 0.15rem;
        }
        .form-select-city {
          flex: 1;
          .select-type {
            width: 98%;
            height: 0.35rem;
            position: relative;
            padding-right: 0.1rem;
            border-radius: 0.15rem;
            background:rgba(247,244,241,1);
            .select-type-left {
              width: 100%;
              text-align: left;
              line-height: 0.36rem;
              span {
                margin-left: 0.15rem;
                font-size: 0.12rem;
              }
            }
            .select-type-top {
              position: absolute;
              top: 0.1rem;
              right: 0.1rem;
              img {
                width: 0.18rem;
                height: 0.15rem;
              }
            }
          }
        }
      }
      .form-select-type {
        padding-top: 0.15rem;
        .select-type {
          width: 98%;
          height: 0.35rem;
          position: relative;
          padding-right: 0.1rem;
          border-radius: 0.15rem;
          background:rgba(247,244,241,1);
          .select-type-left {
            width: 100%;
            text-align: left;
            line-height: 0.36rem;
            span {
              margin-left: 0.15rem;
              font-size: 0.12rem;
            }
          }
          .select-type-top {
            position: absolute;
            top: 0.1rem;
            right: 0.1rem;
            img {
              width: 0.18rem;
              height: 0.15rem;
            }
          }
        }
      }
      .form-phone {
        width: 100%;
        padding: 0.15rem 0;
        .cube-input::after {
          border: 0;
        }
        .phone-style {
          padding: 0.03rem 0.1rem;
          background:rgba(247,244,241,1);
          border-radius: 0.15rem;
          font-size: 0.12rem;
          line-height: 0;
          height: 0.3rem;
          ::-webkit-input-placeholder {
            color: #323232;
            font-size: 0.12rem;
            line-height: 0.15rem;
          }
        }
        :-moz-placeholder {
          font-size: 0.12rem;
          color: #323232;
        }
        ::-moz-placeholder {
          font-size: 0.12rem;
          color: #323232;
        }
        input:-ms-input-placeholder {
          font-size: 0.12rem;
          color: #323232;
        }
        input::-webkit-input-placeholder {
          font-size: 0.12rem;
          color: #323232;
        }
      }
      .form-verify {
        width: 100%;
        position: relative;
        .cube-input::after {
          border: 0;
        }
        .verify-style {
          padding: 0.03rem 0.1rem;
          background:rgba(247,244,241,1);
          border-radius: 0.15rem;
          font-size: 0.12rem;
          line-height: 0;
          height: 0.3rem;
          ::-webkit-input-placeholder {
            color: #323232;
            font-size: 0.12rem;
            line-height: 0.15rem;
          }
        }
        button {
          position: absolute;
          top: 0.08rem;
          right: 0.04rem;
          font-size: 0.12rem;
          color: #E93789;
          border: 0;
          outline: 0;
          background:rgba(247,244,241,1);
        }
        :-moz-placeholder {
          font-size: 0.12rem;
          color: #323232;
        }
        ::-moz-placeholder {
          font-size: 0.12rem;
          color: #323232;
        }
        input:-ms-input-placeholder {
          font-size: 0.12rem;
          color: #323232;
        }
        input::-webkit-input-placeholder {
          font-size: 0.12rem;
          color: #323232;
        }
      }
    }
    .register-but {
      position: absolute;
      width: 100%;
      bottom: 0.12rem;
      left: 0;
      text-align: center;
      img {
        width: 3rem;
        height: 0.6rem;
      }
    }
  }
  .plk-reg-03 {
    position: relative;
    .plk-reg-box {
      position: absolute;
      bottom: 0.1rem;
      width: 100%;
      display: flex;
      text-align: center;
      .plk-reg-share {
        flex: 1;
        img {
          width: 1.5rem;
          height: 0.6rem;
        }
      }
      .plk-reg-kefu {
        flex: 1;
        img {
          width: 1.5rem;
          height: 0.6rem;
        }
      }
    }
  }
}
// 遮罩层 客服二维码
.mode {
  // display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.7);
  .dialog-box {
    position: fixed;
    top: 10%;
    width: 100%;
    .dialog-img {
      position: relative;
      img {
        width: 100%;
      }
      .qrcode {
        position: absolute;
        top: 0.5rem;
        left: 0.7rem;
        width: 60%;
        img {
          width: 100%;
        }
      }
    }
    .dialog-close {
      position: absolute;
      bottom: -0.5rem;
      left: 0;
      width: 100%;
      text-align: center;
      img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
  }
}
.modeshare{
  // display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.7);
  text-align: right;
  .share-guide {
    padding: 0.12rem 0.12rem 0 0.15rem;
    img {
      max-width: 80%
    }
  }
  .share-ok {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 0;
    text-align: center;
    img {
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 0;
      width: 1.4rem;
      height: 0.4rem;
    }
  }
}
</style>
